import React from 'react'
import { Button as MuiButton, styled } from '@mui/material'
import { useNetwork } from 'wagmi'
import { parseUnits } from 'ethers/lib/utils'
import { toast } from 'react-toastify'
import { BigNumber } from 'ethers'
import { useAllowance, useApprove } from '@/hooks/brc20Hooks'
import { useStake } from '@/hooks/farmHooks'
import { getFarmContractAddress } from '@/utils/contract'

const Button = styled(MuiButton)`
  height: 48px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
`

const StakeButton = ({
  amount,
  poolId,
  decimal,
  disabled,
  onSuccess,
  tokenAddress,
  brc20Balance,
}: {
  amount: string
  poolId: number
  decimal: number
  disabled: boolean
  onSuccess: () => void
  tokenAddress: string
  brc20Balance?: BigNumber
}) => {
  const { chain } = useNetwork()

  const farmAdress = getFarmContractAddress(chain?.id)

  const { data: allowance, run: getAllowance } = useAllowance(tokenAddress, farmAdress)

  // console.log('allowance: ', allowance?.toString())

  const { loading: isApproving, run: approve } = useApprove(tokenAddress, {
    onSuccess: () => {
      toast.success('Approved successfully')
      setTimeout(() => {
        getAllowance()
      }, 500)
    },
  })

  const parsedAmount = parseUnits(amount || '0')

  const { run: stake, loading: isStaking } = useStake(poolId, amount ? parseUnits(amount, decimal) : '0', {
    onSuccess: () => {
      setTimeout(() => {
        onSuccess()
      }, 500)
    },
  })

  if (brc20Balance?.lt(parseUnits(amount || '0', decimal))) {
    return (
      <Button variant="contained" disabled>
        Insufficient Balance
      </Button>
    )
  }

  if (amount && allowance?.lt(parsedAmount)) {
    return (
      <Button
        variant="contained"
        disabled={isApproving || disabled}
        onClick={() => {
          approve(farmAdress, parsedAmount)
        }}
      >
        {isApproving ? 'Approving...' : 'Approve'}
      </Button>
    )
  }

  return (
    <Button variant="contained" disabled={disabled || !amount || isStaking} onClick={stake}>
      {isStaking ? 'Staking...' : 'Stake'}
    </Button>
  )
}

export default StakeButton
